export const USER_GUIDE_LOCAL_STORAGE_KEY = 'USER_GUIDE_LOCAL_STORAGE_KEY';
export const KEY_FEATURE_GUIDE_MAP = {
    auto_update: {
        img: 'auto-update.gif',
    },
    ai_tagging: {
        img: 'ai-tagging.png',
    },
    share: {
        img: 'share.png',
    },
};
